module.exports = __webpack_public_path__ + "img/66.b5d99e79.png";